/* eslint-disable react/require-default-props */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import {
  TmntHtml, TmntText, LegalButton, LegalModal,
} from '../../Common';
import * as FormStructure from '../../FormStructure';
import EmailUsFormV2 from './EmailUsFormV2';
import { ModalContextProvider } from '../../../context/ModalContext';
import { useLegalLinkEvents } from '../../../hooks';
import { refProp } from '../../../tools/customProps';

export default function EmailUsContainerV2({
  formRef = undefined,
  formIsInvalid = false,
  invalidFields = undefined,
  selectedReason = '',
  setSelectedReason,
  handleOnSubmit,
  handleHelpReasonChange,
  text,
}) {
  // capture legal text key from TMNT
  const legalLinkRef = useRef(null);
  const [legalTmntKey, setLegalTmntKey] = useState(null);
  useLegalLinkEvents(legalLinkRef, (value) => {
    setLegalTmntKey(value);
  });

  const {
    buttonSubmit,
    formDisputeLabel,
    formLegal,
    formResponseNote,
    modalHeading,
  } = text;

  const renderSubmitButton = () => (
    <Button
      variant="primary"
      isFullWidth
      type="submit"
      onClick={handleOnSubmit}
      data-testid="email-us-submit-button"
    >
      <TmntText tmnt={buttonSubmit} />
    </Button>
  );

  const renderFormResponsAndLegal = () => (
    <FormStructure.FormGroup>
      <FormStructure.FormCell>
        <TmntHtml tmnt={formResponseNote} />
      </FormStructure.FormCell>
      <FormStructure.FormCell>
        <div data-testid="legal-text">
          <LegalButton
            text={formLegal}
            ref={legalLinkRef}
          />
          {legalTmntKey && (
            <ModalContextProvider>
              <LegalModal
                legalText={legalTmntKey}
                onClose={() => setLegalTmntKey(null)}
              />
            </ModalContextProvider>
          )}
        </div>
      </FormStructure.FormCell>
    </FormStructure.FormGroup>
  );

  const renderDispluteSection = () => formDisputeLabel?.value !== '' && (
    <FormStructure.FormGroup>
      <FormStructure.FormCell>
        <section className="dispute-section">
          <div className="dispute-content" data-testid="email-us-dispute">
            <TmntHtml tmnt={formDisputeLabel} />
          </div>
        </section>
      </FormStructure.FormCell>
    </FormStructure.FormGroup>
  );

  return (
    <EmailUsFormV2
      id="internal-email-us-form__v2"
      label={modalHeading}
      formRef={formRef}
      onSubmit={(e) => e.preventDefault()}
      formIsInvalid={formIsInvalid}
      invalidFields={invalidFields}
      text={text}
      selectedReason={selectedReason}
      setSelectedReason={setSelectedReason}
      handleHelpReasonChange={handleHelpReasonChange}
    >
      {renderFormResponsAndLegal()}
      <FormStructure.FormGroup>
        <FormStructure.FormCell>
          {renderSubmitButton()}
        </FormStructure.FormCell>
      </FormStructure.FormGroup>
      {renderDispluteSection()}
    </EmailUsFormV2>
  );
}

const propTypes = {
  formRef: refProp,
  formIsInvalid: PropTypes.bool,
  invalidFields: PropTypes.arrayOf(PropTypes.string),
  selectedReason: PropTypes.string,
  setSelectedReason: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleHelpReasonChange: PropTypes.func.isRequired,
  text: PropTypes.shape({
    buttonSubmit: PropTypes.string.isRequired,
    formDisputeLabel: PropTypes.string,
    formLegal: PropTypes.string.isRequired,
    formResponseNote: PropTypes.string.isRequired,
    modalHeading: PropTypes.string.isRequired,
  }).isRequired,
};

EmailUsContainerV2.propTypes = propTypes;
